import api from '../utils/baseUrl';

class ClickService {
    async validateClick(clickId: string, payload: object) {
        try {
            await api.post(`/api/clicks/${clickId}/validate`, payload);
        } catch (error) {
            console.error('Error validating click:', error);
            return [];
        }
    }

    async getSiteKey() {
        try {
            const response = await api.get('/api/clicks/chandler');
            return response.data.result ?? {};
        } catch (error) {
            console.error('Error retrieving site key:', error);
            return [];
        }
    }
}

export default new ClickService();